import axios from "axios";
import { api } from "./helper";
import router from "../routes/routes";
import store from "../store"
import { v4 as uuidv4 } from 'uuid';

const client = axios.create({
  baseURL: api,
  withCredentials: false,
});

client.interceptors.request.use((config) => {
  config.headers.Authorization = "Bearer " + store.state.user.jwt;
  return config;
});

function prepareDataRequest(data) {
  return {
    RequestCorrelationId: uuidv4(),
    Data: data
  };
}

function prepareRequest(data) {
  return {
    ...data,
    RequestCorrelationId: uuidv4()
  };
}

client.interceptors.response.use(
  (response) => {
    if (!response.data.data)
      if (response.data.data.indexOf("Unauthorized") > -1) {
        router.push("/logout");
      }
    return response;
  },
  (error) => {
    return { data: error.message };
    // return Promise.reject(error.response);
  }
);

function GetRegions() {
  return client.post("Classifiers/GetRegions", prepareRequest({}));
}

function CreateServiceCenter(item) {
  return client.post("Classifiers/ServiceCenterInsert", prepareRequest(item));
}

function UpdateServiceCenter(item) {
  return client.post("Classifiers/ServiceCenterUpdate", prepareRequest(item));
}

function GetIncidentCauses(type) {
  const data = { type }; 
  return client.post("Classifiers/GetIncidentCauses", prepareRequest(data));
}

function GetPolicyTypes(type) {
  const data = { type };
  return client.post("Classifiers/GetPolicyTypes", prepareRequest(data));
}

function GetAccidentFinishReasons() {
  return client.post("Classifiers/GetAccidentFinishReasons", prepareRequest({}));
}

function GetBrand() {
  return client.post("Classifiers/GetBrand", prepareRequest({}));
}

function GetModel(id) {
  const data = { id };
  return client.post("Classifiers/GetModel", prepareRequest(data));
}

function GetClaimDocTmpl(id) {
  const data = { id };
  return client.post("Classifiers/GetClaimDocTmpl", prepareRequest(data));
}

function GetBanks() {
  return client.post("Classifiers/GetBanks", prepareRequest({}));
}

function GetDamageCategories() {
  return client.post("Classifiers/GetDamageCategories", prepareRequest({}));
}

function GetStages() {
  return client.post("Classifiers/GetStages", prepareRequest({}));
}

function GetActiveServiceCenters() {
  return client.post("Classifiers/GetActiveServiceCenters", prepareRequest({}));
}

function GetAllServiceCenters() {
  return client.post("Classifiers/GetAllServiceCenters", prepareRequest({}));
}


function GetServiceCenter(id) {
  const data = { id };
  return client.post("Classifiers/GetServiceCenter", prepareRequest(data));
}


function DeleteServiceCenter(id, uid) {
  var item = { id: id, commandUserId: uid };
  return client.delete("Classifiers/ServiceCenterDelete", { data: prepareDataRequest(item) });
}

function GetMedDamageTypes() {
  return client.post("Classifiers/GetMedDamageTypes", prepareRequest({}));
}

function GetOfficialAgency() {
  return client.post("Classifiers/GetOfficialAgency", prepareRequest({}));
}

function GetInsuranceCompanies() {
  return client.post("Classifiers/GetInsuranceCompanies", prepareRequest({}));
}

function GetRegion(id) {
  const data = { id };
  return client.post("Classifiers/GetRegion", prepareRequest(data));
}

function GetInsuranceCompany(id) {
  const data = { id };
  return client.post("Classifiers/GetInsuranceCompany", prepareRequest(data));
}




export {
  GetRegions, GetAccidentFinishReasons, GetBrand, GetModel, GetClaimDocTmpl, GetAllServiceCenters, GetActiveServiceCenters,
  GetBanks, GetDamageCategories, GetStages, CreateServiceCenter, UpdateServiceCenter, DeleteServiceCenter, GetServiceCenter, GetMedDamageTypes,
  GetIncidentCauses, GetOfficialAgency, GetInsuranceCompanies, GetPolicyTypes, GetRegion, GetInsuranceCompany
};